export default "__VITE_ASSET__DJWFsDSh__"